/** Profile decoded from TID id_token (and restored from sessionStorage). */
export interface TidUser {
  firstName?: string
  lastName?: string
  email?: string
  img?: string
  id?: string
  tid?: string
}

export const initialLoginState: LoginState = {
  token: null,
  authTime: null,
  idToken: null,
  refreshToken: null,
  user: null,
}

export interface LoginState {
  /** OAuth access token */
  token: string | null
  /** Epoch ms when access token was issued, as string */
  authTime: string | null
  /** OpenID Connect ID token (e.g. for logout hint) */
  idToken: string | null
  /** OAuth refresh token */
  refreshToken: string | null
  /** Logged-in user profile from id_token / session */
  user: TidUser | null
}

/** The user is authenticated if the access token is present. */
export function isUserAuthenticated(state: LoginState | null | undefined): boolean {
  if (!state) return false
  return Boolean(state.token)
}

export type LoginAction =
  | {
      type: "SET_LOGIN"
      payload: {
        token: string
        authTime: string
        idToken: string
        refreshToken: string
        /** If omitted, existing profile is kept (e.g. token-only refresh). */
        user?: TidUser | null
      }
    }
  | { type: "SET_USER"; payload: TidUser | null }
  | { type: "LOG_OUT" }

export const loginReducer = (
  state: LoginState,
  action: LoginAction,
): LoginState => {
  switch (action.type) {
    case "SET_LOGIN":
      return {
        token: action.payload.token,
        authTime: action.payload.authTime,
        idToken: action.payload.idToken,
        refreshToken: action.payload.refreshToken,
        user:
          action.payload.user !== undefined
            ? action.payload.user
            : state.user,
      }
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      }
    case "LOG_OUT":
      sessionStorage.removeItem("accountId")
      sessionStorage.removeItem("user_info")
      localStorage.removeItem("id_link")
      localStorage.removeItem("currency")
      localStorage.removeItem("country")
      return initialLoginState
    default:
      return state
  }
}
